<template>
  <fin-dialog v-model="show" hideCloseButton :max-width="500">
    <template #title>
      Zeitüberschreitung
    </template>

    Du warst seit 15 Minuten nicht mehr aktiv und wirst deshalb in {{ time }} Sekunden ausgeloggt. Willst du die Sitzung
    verlängern?
    <template #actions>
      <v-btn @click="click">Sitzung verlängern</v-btn>
    </template>

  </fin-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex"

const TIMETOEXTEND = 30 // 30 seconds
const ALLTABSIDLETIME = 10 //10 seconds, sync time

export default {
  name: "idleCheck",
  data() {
    return {
      time: 0,
      show: false,
      timerId: null,
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    isIdle() {
      return this.$store.state.idleVue.isIdle
    }
  },
  watch: {
    isIdle: {
      handler(val) {
        if (!val) {
          if (!this.show) {
            localStorage.setItem('idle', null)
          }
        }
      },
      immediate: true
    },
  },
  mounted() {
    localStorage.setItem('idle', null)
    this.timerId = setInterval(() => {
      try {
        let userSession = this.user.getSignInUserSession()

        const expires = userSession.getIdToken().payload.exp - Math.floor(new Date().getTime() / 1000)
        //console.log(`Token expires in ${ expires } seconds`)

        // inactive window / tabs => the interval is just 1 minute, so we refresh 5 min before expiry
        if (expires < 60 * 5) {
          this.refreshSession()
        }

        // reset start of idle time as long as user is active and popup isnt shown yet
        if (!this.show && !this.isIdle) {
          localStorage.removeItem('idle')
          return
        }
        // save the time when user went idle, after
        let sessionVal = localStorage.getItem('idle')
        if (!sessionVal) {
          sessionVal = Date.now()
          localStorage.setItem('idle', '' + sessionVal)
        }
        // after ALLTABSIDLETIME has passed, popup is shown for TIMETOEXTEND, after which the timer is cleared and user gets logged out
        const idle = Math.floor((Date.now() - sessionVal) / 1000)
        this.time = ALLTABSIDLETIME + TIMETOEXTEND - idle
        this.show = this.time <= TIMETOEXTEND
        if (this.time < 1) {
          clearInterval(this.timerId)
          this.logOut()
        }
      } catch (e) {
        if (!this.user) {
          this.$router.push('/').catch(err => console.log('Error signing out from AWS', err))
        } else {
          this.logOut()
        }
      }
    }, 1000)
  },
  destroyed() {
    clearInterval(this.timerId)
  },
  methods: {
    ...mapActions('auth', ['signOut', 'refreshSession']),
    click() {
      localStorage.removeItem('idle')
      this.show = false
    },
    async logOut() {
      await this.signOut()
      await this.$router.push('/').catch(err => console.log('Error signing out from AWS', err))
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
